import type { AnyValue } from '@mntn-dev/utility-types'

export function runIfFn<T extends AnyValue>(valueOrFn: T, ...args: unknown[]) {
  if (typeof valueOrFn === 'function') {
    return valueOrFn(args)
  }

  return valueOrFn
}
